import { GivingStrategy } from './api/useCharitableGivingQuery';

export type Step =
  | 'givingStrategy'
  | 'dafAccount'
  | 'kindOfProperty'
  | 'donor'
  | 'donationAmount'
  | 'donationYear'
  | 'dafDonationYear'
  | 'dafGrantAmount'
  | 'dafGrantYear'
  | 'charityName'
  | 'fundAccounts'
  | 'review';

export const STEPS_DICT: Record<GivingStrategy, Step[]> = {
  [GivingStrategy.DonationToDAF]: [
    'givingStrategy',
    'dafAccount',
    'kindOfProperty',
    'donationAmount',
    'dafDonationYear',
    'dafGrantYear',
    'dafGrantAmount',
    'fundAccounts',
    'review',
  ],

  [GivingStrategy.OutrightGiftsToCharity]: [
    'givingStrategy',
    'kindOfProperty',
    'donationAmount',
    'donationYear',
    'charityName',
    'fundAccounts',
    'review',
  ],

  [GivingStrategy.QualifiedCharitableDonations]: [
    'givingStrategy',
    'donor',
    'donationAmount',
    'donationYear',
    'charityName',
    'fundAccounts',
    'review',
  ],
};

export const INPUTS_WIDTH = 306;

export const CARDS_WIDTH = 712;
